import React from 'react';

import { AddTestCasesForm } from '@qality/common-components/src/molecules/AddTestCasesForm';

import { AddTestCasesWizardPageStyled } from './AddTestCasesWizardPage.styled';

const AddTestCasesWizardPage = () => {
  return (
    <AddTestCasesWizardPageStyled>
      <AddTestCasesForm />
    </AddTestCasesWizardPageStyled>
  );
};

export default AddTestCasesWizardPage;
